export class SettingData {
  min_money: number;
  id: string;
  isloop: boolean;
  times: number;
  basetime: number;
  img1: string;
  img2: string;
  img3: string;
  img4: string;
  msg: string;
  opay_payment_hash: string;
  merchantID: string;
  hashKey: string;
  hashIV: string;
  // youtubeRestrictionLevel: number;
  volume: number;
  voiceVolume: number;
  constructor(min_money: number, id: string, isloop: boolean, times: number,
              basetime: number, img1: string, img2: string, img3: string, img4: string , msg: string,
              opay_payment_hash: string, volume: number, voiceVolume: number) {
      this.min_money = min_money;
      this.id = id;
      this.isloop = isloop;
      this.times = times;
      this.basetime = basetime;
      this.img1 = img1;
      this.img2 = img2;
      this.img3 = img3;
      this.img4 = img4;
      this.msg = msg;
      this.opay_payment_hash = opay_payment_hash;
      this.volume = volume;
      this.voiceVolume = voiceVolume;
      // this.youtubeRestrictionLevel = youtubeRestrictionLevel;
      // this.merchantID = merchantID;
      // this.hashKey = hashKey;
      // this.hashIV = hashIV;
  }
}
